import { render, staticRenderFns } from "./LoanCollateralAsset.vue?vue&type=template&id=daed2770&scoped=true&lang=pug&"
import script from "./LoanCollateralAsset.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAsset.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAsset.vue?vue&type=style&index=0&id=daed2770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daed2770",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAsset.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports